var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("notifications"),
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c("guest-navbar", {
            on: {
              headerLoginClicked: _vm.onHeaderLoginClicked,
              userClicked: function ($event) {
                return _vm.handleUserClicked()
              },
            },
          }),
          _c(
            "div",
            [
              _c("GuestHome", {
                on: {
                  dblClick: function ($event) {
                    return _vm.handleDblClick()
                  },
                },
              }),
              _c(
                "SidebarRight",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.outside,
                      expression: "outside",
                    },
                  ],
                  class: [
                    "navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400",
                    { open: _vm.showSideBar },
                  ],
                },
                [
                  _c(
                    "transition",
                    { attrs: { name: "slide-fade", mode: "out-in" } },
                    [
                      _c(_vm.currentView, {
                        tag: "component",
                        on: {
                          iAmNewClicked: _vm.handleIAmNewClicked,
                          backClickedFromRegister: function ($event) {
                            _vm.currentView = "Login"
                          },
                          backClickedFromForgot: function ($event) {
                            _vm.currentView = "Login"
                          },
                          forgotPasswordLinkClicked: function ($event) {
                            _vm.currentView = "Forgot"
                          },
                          registerSuccess: _vm.onRegisterSuccess,
                          resetPasswordSuccess: _vm.onResetPasswordSuccess,
                          userVerified: _vm.onUserVerificationSuccess,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }